import pic1 from "../images/onboarding/pic1.png";
import pic2 from "../images/onboarding/pic2.png";
import pic3 from "../images/onboarding/pic3.png";
import pic4 from "../images/onboarding/pic4.png";
import pic5 from "../images/onboarding/pic5.png";

export default [pic1, pic2, pic3, pic4, pic5];
